import * as UserAccount from 'constants/user-account';

interface PersonalData {
  givenName?: string;
  familyName?: string;
}

interface TrialEligibilityStatusAction {
  type: typeof UserAccount.TRIAL_ELIGIBILITY_STATUS;
  trialEligibilityStatus: string;
}

interface UpdatePersonalDataRequestAction {
  type: typeof UserAccount.UPDATE_PERSONAL_DATA_REQUEST;
  personalData: PersonalData;
}

interface UpdatePersonalDataSuccessAction {
  type: typeof UserAccount.UPDATE_PERSONAL_DATA_SUCCESS;
}

interface UpdatePersonalDataFailureAction {
  type: typeof UserAccount.UPDATE_PERSONAL_DATA_FAILURE;
  error: unknown;
}

export function trialEligibilityStatus(value: string): TrialEligibilityStatusAction {
  return { type: UserAccount.TRIAL_ELIGIBILITY_STATUS, trialEligibilityStatus: value };
}

export function updatePersonalDataRequest(
  personalData: PersonalData,
): UpdatePersonalDataRequestAction {
  return {
    type: UserAccount.UPDATE_PERSONAL_DATA_REQUEST,
    personalData,
  };
}

export function updatePersonalDataSuccess(): UpdatePersonalDataSuccessAction {
  return {
    type: UserAccount.UPDATE_PERSONAL_DATA_SUCCESS,
  };
}

export function updatePersonalDataFailure(error: unknown): UpdatePersonalDataFailureAction {
  return {
    type: UserAccount.UPDATE_PERSONAL_DATA_FAILURE,
    error,
  };
}

export function updateGivenName(givenName: string): UpdatePersonalDataRequestAction {
  return updatePersonalDataRequest({
    givenName,
  });
}

export function updateFamilyName(familyName: string): UpdatePersonalDataRequestAction {
  return updatePersonalDataRequest({
    familyName,
  });
}
